"use client";
import { useEffect, useState } from "react";

declare const navigator: any; // This is the declaration you add
// Ensure that you have the correct type for PermissionName
type PermissionName =
  | "geolocation"
  | "notifications"
  | "push"
  | "midi"
  | "camera"
  | "microphone"
  | "speaker"
  | "device-info"
  | "background-fetch"
  | "background-sync"
  | "bluetooth"
  | "persistent-storage"
  | "ambient-light-sensor"
  | "accelerometer"
  | "gyroscope"
  | "magnetometer"
  | "clipboard-read"
  | "clipboard-write"
  | "payment-handler";

function useNavigatorPermissions(name: PermissionName) {
  const [result, setResult] = useState<boolean | null>(null);

  useEffect(() => {
    // Assuming `navigator.permissions` is available
    if (!navigator.permissions) {
      console.error("Navigator permissions API is not available.");
      return;
    }

    navigator.permissions
      .query({ name })
      .then((permissionStatus: PermissionStatus) => {
        // Handle permission status
        switch (permissionStatus.state) {
          case "granted":
            setResult(true);
            break;
          case "denied":
            setResult(false);
            break;
          default:
            // Handle other cases such as 'prompt'
            setResult(null);
            break;
        }
      })
      .catch((error: any) => {
        console.error("Error querying permissions:", error);
        setResult(false);
      });
  }, [name]);

  return result;
}

export default useNavigatorPermissions;
